import styles from "./style.module.scss";
import Kitchen from "src/assets/kitchen.jpg";

export const KitchenSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h3>
          Dining Kitchen<span>-ダイニング・キッチン-</span>
          <div className={styles.border} />
        </h3>
        <div className={styles.imageBox}>
          <img src={Kitchen} alt="kitchen" />
        </div>
        <div className={styles.grayBox} />
        <div className={styles.whiteBox}>
          <p>
            調理しやすい広々としたキッチンで、自宅以上に調理器具や食器も充実。また、玄関のすぐ奥にあるため、魚の処理や調理にすぐに取り掛かれます。複数人で同時に調理もでき、子供の料理の練習にもうってつけ。
          </p>
        </div>
      </div>
    </section>
  );
};
